import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Gauge } from "lucide-react";
import { CHART, ChartCard, ChartEmpty, TooltipBox, axisTick } from "./ui";

const BUCKET_COLORS = [CHART.danger, CHART.warning, CHART.info, CHART.success];
const BUCKET_LABELS = ["Needs Work", "Fair", "Good", "Excellent"];

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload || payload.length === 0) return null;
  const d = payload[0]?.payload || {};
  return <TooltipBox title={d.label}><span>{d.count} questions</span></TooltipBox>;
};

const ConfidenceHistogram = ({ buckets }: any) => {
  const card = (body) => (
    <ChartCard icon={<Gauge />} title="Answer Quality" description="How confident the chatbot was in its answers.">{body}</ChartCard>
  );
  if (!buckets || buckets.length === 0) {
    return card(<ChartEmpty icon={<Gauge />} text="No quality data available" />);
  }

  const chartData = buckets.map((b, idx) => ({
    label: BUCKET_LABELS[idx] || b.label || "",
    count: b.count || 0,
    color: BUCKET_COLORS[idx] || CHART.muted,
  }));

  return card(
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={chartData} margin={{ top: 20, right: 10, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART.grid} vertical={false} />
        <XAxis dataKey="label" tick={{ ...axisTick, fontSize: 12 }} tickLine={false} axisLine={{ stroke: CHART.grid }} />
        <YAxis tick={axisTick} tickLine={false} axisLine={false} allowDecimals={false} />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "var(--accent)" }} />
        <Bar dataKey="count" radius={[4, 4, 0, 0]} label={{ position: "top", fontSize: 11, fill: CHART.text }}>
          {chartData.map((entry, idx) => <Cell key={idx} fill={entry.color} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ConfidenceHistogram;
